import type {AddLeadNoteFormPayload} from "./add-lead-note.schema";

import {addLeadNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../../../lead-keys";

export function addLeadNoteMutationOptions(leadId: string) {
  return mutationOptions({
    mutationKey: leadMutationKeys.addLeadNote,
    mutationFn: (formPayload: AddLeadNoteFormPayload) => addLeadNote(leadId, formPayload),
    onSuccess: async (_noteId, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.detail(leadId)});
    },
  });
}
